import { Box, styled, Typography } from '@mui/material';

import { BaseButtonStyled } from 'theSource/components';

export const IdCardStyled = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `0.2rem dashed ${theme.palette.primaryDark.main}`,
  minHeight: '18rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ImageStyled = styled('img')({
  maxWidth: '100%',
});

export const IdCardWrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const IdCardHeaderStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [BaseButtonStyled]: {
    minWidth: '2.5rem',
  },
});

export const IdCardTitleStyled = styled(Typography)({
  wordBreak: 'break-word',
});
